// extracted by mini-css-extract-plugin
export default {"uploadGroup":"Upload_uploadGroup__-AhLx"};